<template>
    <div class="eCommerce-container">
        <el-table :data="infoList" class="customTable" style="width: 100%; margin-top: 20px; flex: 1" height="1%" @sort-change="sortChange">
            <el-table-column label="排名" align="center" width="100px">
                <template slot-scope="scope">
                    <div class="sort-img" v-if="scope.row.rank < 4">
                        <img v-if="scope.row.rank === 1" :src="require('../../../../assets/images/student/num-01.png')" alt="">
                        <img v-else-if="scope.row.rank === 2" :src="require('../../../../assets/images/student/num-02.png')" alt="">
                        <img v-else :src="require('../../../../assets/images/student/num-03.png')" alt="">
                    </div>
                    <div class="sort-num" v-else>{{scope.row.rank | formatRank}}</div>
                </template>
            </el-table-column>
            <el-table-column label="商品信息">
                <template slot-scope="scope">
                    <div class="goods-info">
                        <div class="good-img" @click="toGoodDetail(scope.row.good_id)">
                            <img :src="scope.row.good_images" alt="">
                        </div>
                        <div class="info-right text-overflow-2" @click="toGoodDetail(scope.row.good_id)">{{scope.row.good_name}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="trading_money" label="成交金额指数" align="center" sortable="custom" width="140px">
                <template slot-scope="scope">{{scope.row.sum_trading_money}}</template>
            </el-table-column>
            <el-table-column prop="trading_order" label="成交单量指数" align="center" sortable="custom" width="140px">
                <template slot-scope="scope">{{scope.row.sum_trading_order}}</template>
            </el-table-column>
            <el-table-column prop="visitor_number" label="访客指数" align="center" sortable="custom" width="140px">
                <template slot-scope="scope">{{scope.row.sum_visitor_number}}</template>
            </el-table-column>
            <el-table-column prop="search_click_number" label="搜索点击量指数" align="center" sortable="custom" width="160px">
                <template slot-scope="scope">{{scope.row.sum_search_click_number}}</template>
            </el-table-column>
            <el-table-column prop="followers_number" label="关注人数" align="center" sortable="custom" width="160px">
                <template slot-scope="scope">{{scope.row.sum_followers_number}}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160px">
                <template slot-scope="scope">
                    <el-link type="success" :underline="false" @click="detailBtn(scope.row.good_id)">详情</el-link>
                </template>
            </el-table-column>
            <template slot="empty">
                <div class="null-data">
                    <div style="display: flex;flex-direction: column;align-items: center;">
                        <img src="../../../../assets/images/student/goods-null-data.png" alt="">
                        <span>暂无数据</span>
                    </div>
                </div>
            </template>
        </el-table>
        <el-pagination class="pages-center" style="margin: 20px 0 30px" v-if="infoList.length > 0"
                       :current-page="listPages.currentPageNum"
                       :page-size="listPages.eachPageNum"
                       layout="prev, pager, next, jumper"
                       :total="listPages.total"
                       @current-change="pagesCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
    import { dataCentorTplCommodityListExam } from '@/utils/apis.js'
    export default {
        filters: {
            formatRank(val) {
                if (val < 10) {
                    return `0${val}`
                } else {
                    return val
                }
            }
        },
        data() {
            return {
                infoList: [],
                listPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0
                },
                order_name: void 0,
                order_type: void 0,
                isExamOrTrain: localStorage.getItem('examId'), // 有考试， 没有训练
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            // 获取列表
            getList() {
                let params = {
                    data_center_tpl_id: this.$route.query.data_center_tpl_id,
                    paging: 1,
                    page: this.listPages.currentPageNum,
                    pageSize: this.listPages.eachPageNum,
                }
                if (this.order_name) {
                    params.ordering = 1
                    params.order_name = this.order_name
                } else {
                    params.ordering = 0
                }
                if (this.order_type) {
                    params.ordering = 1
                    params.order_type = this.order_type
                } else {
                    params.ordering = 0
                }
                dataCentorTplCommodityListExam(params).then((res) => {
                    const getValue = (value) => value * 1;
                    res.data.list.forEach(item => {
                        item.sum_followers_number = getValue(item.sum_followers_number);
                        item.sum_search_click_number = getValue(item.sum_search_click_number);
                        item.sum_trading_money = getValue(item.sum_trading_money);
                        item.sum_trading_order = getValue(item.sum_trading_order);
                        item.sum_visitor_number = getValue(item.sum_visitor_number);
                    })
                    this.infoList = res.data.list
                    this.listPages.total = res.data.total
                })
            },
            // 自定义表格数据排序
            sortChange(column, prop, order) {
                this.order_name = column.prop
                if (column.order === 'ascending') {
                    this.order_type = 'asc'
                } else if (column.order === 'descending') {
                    this.order_type = 'desc'
                } else {
                    this.order_type = void 0
                }
                this.listPages.currentPageNum = 1
                this.getList()
            },
            // 切换分页
            pagesCurrentChange(val) {
                this.listPages.currentPageNum = val
                this.getList()
            },
            // 去商品详情
            toGoodDetail(id) {
                let routeDate = this.$router.resolve({
                    path: '/goods/detail',
                    query:{
                        g_id: id,
                        type: 1
                    }
                })
                window.open(routeDate.href, '_blank')
            },
            // 详情
            detailBtn(id) {
                if (this.isExamOrTrain) {
                    this.$router.push({
                        path: '/student/exam/ECommerceDataAnalysisAndApplication/productDetail',
                        query: {
                            op_id: this.$route.query.op_id,
                            exam_module_id: this.$route.query.exam_module_id,
                            data_center_tpl_id: this.$route.query.data_center_tpl_id,
                            id: id
                        }
                    })
                } else {
                    this.$router.push({
                        path: '/student/trainCenter/ECommerceDataAnalysisAndApplication/productDetail',
                        query: {
                            op_id: this.$route.query.op_id,
                            exam_module_id: this.$route.query.exam_module_id,
                            course_id: this.$route.query.course_id,
                            data_center_tpl_id: this.$route.query.data_center_tpl_id,
                            id: id,
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .eCommerce-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
    }
    .sort-num {
        display: inline-block;
        background: #e7f6ef;
        height: 24px;
        width: 24px;
        border-radius: 12px;
        line-height: 24px;
        text-align: center;
    }
    .sort-img {
        display: inline-block;
        img {
            display: block;
        }
    }
    .goods-info {
        display: flex;
        align-items: center;
        .good-img {
            width: 80px;
            height: 80px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
                max-width: 100%;
            }
        }
        .info-right {
            width: 1%;
            flex: 1;
            margin-left: 10px;
            cursor: pointer;
        }
    }
</style>